var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-text-field',{attrs:{"label":"Rubrik","hint":"Obligatorisk","persistent-hint":"","outlined":"","rules":[_vm.required],"disabled":_vm.readonly},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }